<template>
    <div class="description-list" :class="{ 'keep-table': keepTable }">
        <div class="list-body">
            <div v-for="(item, index) in items" :key="'description' + index" class="list-row">
                <div class="list-item definition">
                    <slot name="column1" :item="item"> </slot>
                </div>
                <div class="list-item value">
                    <slot name="column2" :item="item"> </slot>
                </div>
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DescriptionList',
    props: {
        items: {
            type: Array
        },
        keepTable: Boolean
    }
};
</script>

<style lang="scss">
@use '@/styles/theming' as *;
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.description-list {
    .list-body {
        display: table;

        .list-row {
            display: table-row;

            .list-item {
                display: table-cell;
            }
        }
    }

    .list-item {
        line-height: 1.5rem;
        padding-bottom: 0.8rem;

        &:first-child {
            color: var(--body-color-disabled);
            padding-right: 10px;
            font-weight: normal;
        }

        &:last-child {
            padding-left: 10px;
        }

        &.definition::after {
            content: ':';
            position: absolute; //prevents from line breaking
        }
    }

    &:not(.keep-table) {
        @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
            .list-body,
            .list-body .list-row,
            .list-body .list-row .list-item {
                display: block;
            }

            .list-item.definition {
                line-height: 1.5em;
            }

            .list-item.value {
                margin-left: 30px;
                line-height: 1.2em;
                margin-bottom: 5px;
            }
        }
    }
}
</style>
